export const backstageVer = '1.0.76'


/**
 * 正式服beta切换
 * v1 正式服
 * v2 beta
 */
export const apiEdition = process.env.NODE_ENV === 'development' ? 'v2' : 'v2'   // 这串是在线上运行的，下面改成自己判断的了，不行就换回来
// export const apiEdition = 'v1'   // 这串是开发时候用=的，下面改成自己判断的了，不行就换回来



/**
 * 各种原始文件
 */
export const ConVendorNameMap = new Map()
  .set(0, {
    vendorID: 0,
    name: '京东',
    nick: '东'
  })
  .set(1, {
    vendorID: 1,
    name: '美团',
    nick: '美'
  })
  .set(3, {
    vendorID: 3,
    name: '饿百',
    nick: '百'
  })
  .set(14, {
    vendorID: 14,
    name: '抖店',
    nick: '抖'
  })
  .set(16, {
    vendorID: 16,
    name: '淘鲜达',
    nick: '淘'
  })
  // .set(5, {
  //   vendorID: 5,
  //   name: '京狗',
  //   nick: '狗'
  // })
  .set(9, {
    vendorID: 9,
    name: '京西',
    nick: '西'
  })
export const ConVendorName = [
  {
    vendorID: 0,
    name: '京东',
    nick: '东'
  },
  {
    vendorID: 1,
    name: '美团',
    nick: '美'
  },
  {
    vendorID: 3,
    name: '饿百',
    nick: '百'
  },
  {
    vendorID: 14,
    name: '抖店',
    nick: '抖'
  },
  {
    vendorID: 16,
    name: '淘鲜达',
    nick: '淘'
  },
  // {
  //   vendorID: 5,
  //   name: '京狗',
  //   nick: '狗'
  // },
  {
    vendorID: 9,
    name: '京西',
    nick: '西'
  }
]
export const ConVendorName2 = [
  {
    vendorID: 0,
    name: '京东',
    nick: '东'
  },
  {
    vendorID: 1,
    name: '美团',
    nick: '美'
  },
  {
    vendorID: 3,
    name: '饿百',
    nick: '百'
  }
]
export const ConVendorNameWm = [
  {
    vendorID: 0,
    name: '京东',
    nick: '东'
  },
  {
    vendorID: 1,
    name: '美团',
    nick: '美'
  },
  {
    vendorID: 3,
    name: '饿百',
    nick: '百'
  },
  {
    vendorID: 14,
    name: '抖店',
    nick: '抖'
  },
  {
    vendorID: 16,
    name: '淘鲜达',
    nick: '淘'
  },
  // {
  //   vendorID: 5,
  //   name: '京狗',
  //   nick: '狗'
  // },
  {
    vendorID: 9,
    name: '京西',
    nick: '西'
  },
  {
    vendorID: 11,
    name: '微盟',
    nick: '微'
  }
]



/**
 * 各种权限
 */
// 权限 老板+技术
export const permissionTel = ['18980410281', '13684045763', '18160030913', '18048531223', '13684245763', '15908190603', '18109051396', '13012345678', '17344357115']
export const permissionYunyingLeader = ['18982250714', '19136159097', '13012345678']
// 运营专员 非平台
export const permissionTelYunying = ['18982250714', '18383211225', '19982595610', '17338665724', '15708459454', '18482028449', '13608076295', '19136159097', '18583684218', '18782186576', '15983243001', '13012345678', '18111649137']
// 财务
export const financial = ['15928865396', '13012345678']
// 建店同事
export const permissionBuild = ['18328080405', '17380734342', '13012345678']
// 市场同事
export const permissionMarket = ['15208271238', '13012345678']



// WEBPACK FOOTER //
// ./src/config.js